<template>
  <div class="resources__search">
    <form @submit.prevent="updateSearch()">
      <label :for="labelId">Search</label>
      <input
        class="resources__input"
        :id="labelId"
        type="text"
        :aria-label="placeholder"
        :placeholder="placeholder"
        v-model="searchTerm"
        @input="setAutoComplete"
      >
      <button class="resources__submit" type="submit" title="submit search">
        <div class="icon icon--search"><search-svg></search-svg></div>
      </button>
    </form>
    <div class="resources__autocomplete" v-if="showAutocomplete">
      <h4 v-if="autoComplete.filters.length > 0">Filters</h4>
      <ul v-if="autoComplete.filters.length > 0">
        <li v-for="filter in autoComplete.filters" :key="`${filter.name}-${filter.id}`">
          <a href="#" class="resource__autocomplete-result" @click.prevent="selectFilter(filter)">
            {{ filter.name }}
          </a>
        </li>
      </ul>
      <h4 v-if="autoComplete.names.length > 0">Results</h4>
      <ul v-if="autoComplete.names.length > 0">
        <li v-for="item in autoComplete.names" :key="item.id">
          <a
            href="#"
            class="resource__autocomplete-result"
            @click.prevent="selectUnique(item.slug)"
          >
            {{ item.name }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import SearchSvg from '@/components/svg/search.vue';

export default {
  name: 'autocomplete-search',
  components: { SearchSvg },
  props: {
    labelId: String,
    placeholder: String,
    filters: Array,
    names: Array,
  },
  data() {
    return {
      showAutocomplete: false,
    };
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    const urlQuery = params.get('search');
    if (urlQuery) {
      this.$emit('search', urlQuery);
    }
  },
  computed: {
    searchTerm: {
      get() {
        return this.$store.state.searchTerm;
      },
      set(value) {
        this.$store.commit('setSearchTerm', value);
      },
    },
    /**
     * get Autocomplete values
     */
    autoComplete() {
      const re = new RegExp(this.searchTerm, 'i');
      return {
        names: this.names.filter(item => item.name.match(re)),
        filters: this.filters.filter(item => item.name.match(re)),
      };
    },
  },
  methods: {
    /**
     * Determine whether to show the autocomplete prompt
     */
    setAutoComplete() {
      this.showAutocomplete = this.searchTerm && this.searchTerm.length > 0
        && (this.autoComplete.names.length > 0 || this.autoComplete.filters.length > 0);
    },
    /**
     * emit filter selected by autocomplete
     */
    selectFilter(filter) {
      this.$emit('update-filter-selection', { field: filter.field, value: filter.id });
      this.showAutocomplete = false;
    },
    /**
     * send unique filter url to parent
     */
    selectUnique(slug) {
      this.$emit('filter-unique', slug);
      this.showAutocomplete = false;
    },
    /**
     * emit search
     */
    updateSearch() {
      this.$emit('search');
      this.showAutocomplete = false;
    },
  },
};
</script>
